import dayjs from 'dayjs'

/**
 * 將 Unix 毫秒時間戳格式化為本地時區的可讀字串
 * 根據瀏覽器設定的時區進行展示
 */
export function formatTimestamp(timestamp: number | null | undefined): string {
  if (timestamp == null) return '-'
  const normalizedTimestamp = timestamp < 100_000_000_000 ? timestamp * 1_000 : timestamp
  return dayjs(normalizedTimestamp).format('YYYY-MM-DD HH:mm:ss')
}

export function formatDate(timestamp: number | null | undefined): string {
  if (timestamp == null) return '-'
  const normalizedTimestamp = timestamp < 100_000_000_000 ? timestamp * 1_000 : timestamp
  return dayjs(normalizedTimestamp).format('YYYY-MM-DD')
}
